module.exports = __webpack_public_path__ + "static/img/B4定向天线.af962ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type2-1-model/B4定向天线.png
// module id = YwNV
// module chunks = 0